import React, { memo } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Grid from '@mui/material/Grid';

import theme from '../../../../main/theme';
import { BUTTON_VARIANT } from '../../../components/Button';
import Form from '../../../components/Form';
import {
  selectErrors,
  selectIsProcessingPostCorp,
} from '../../../store/selectors/createCorporationSelectors';
import launchDarklyToggles from '../../../utils/launchDarklyToggles';

import { corporationNameTitleStyle, formGridStyle, headerStyle, rootGridStyle } from './styles';

const CreateCorporationForm = memo(({ formData, onSubmit, flags }) => {
  const navigate = useNavigate();
  const isProcessingPostCorp = useSelector(selectIsProcessingPostCorp);
  const errorData = useSelector(selectErrors);
  const isBhDecouple = launchDarklyToggles(flags, 'isWaeBhDecoupled');
  return (
    <Grid container sx={rootGridStyle}>
      <Grid item sx={formGridStyle}>
        <Grid sx={headerStyle}>{LanguageConverterV2('corporation.create.title')}</Grid>
        {isBhDecouple && (
          <Grid sx={corporationNameTitleStyle}>
            {LanguageConverterV2('corporation.create.nameTitle')}
          </Grid>
        )}
        <Form
          buttonData={[
            {
              onClick: () => navigate('/corporations/corporationList'),
              text: LanguageConverterV2('corporation.createButton.goBack'),
              variant: BUTTON_VARIANT.OUTLINED,
              sx: {
                margin: theme.spacing(0, 6.25, 0, 0),
              },
            },
          ]}
          confirmationModal={{
            buttonText: LanguageConverterV2('corporation.createButton.add'),
            submitting: isProcessingPostCorp,
          }}
          formFieldData={formData}
          onSubmit={onSubmit}
          errorData={errorData}
        />
      </Grid>
    </Grid>
  );
});

CreateCorporationForm.propTypes = {
  flags: PropTypes.shape({}),
  formData: PropTypes.arrayOf(PropTypes.shape({})),
  onSubmit: PropTypes.func,
};

export default withLDConsumer()(CreateCorporationForm);
